import { type Event } from 'react-big-calendar';
import { type Appointment as AppointmentResponse } from '@features/appointments';

import type { BlockedTimeOccurrence } from '../../types/blockedTime';

export interface CalendarEvent extends Event {
  id: string;
  eventType: 'appointment' | 'blocked_time';
  title: string;
  start: Date;
  end: Date;
  resourceId: string;
  resource: AppointmentResponse;
  blockedTime?: BlockedTimeOccurrence;
  allDay?: boolean;
}

export interface CalendarResource {
  id: string;
  title: string;
  /** Pastel color token for label-lane columns (undefined for provider columns). */
  color?: string;
  /** What this column represents — drives the header renderer. */
  kind?: 'provider' | 'lane' | 'lane-provider';
  /** Provider sub-label for composite lane::provider columns. */
  providerName?: string;
  /**
   * First column of a lane's run — drives the spanning band (Tier-2): the lane
   * name renders only on the first column so the colored band reads as one bar
   * across the lane's provider sub-columns.
   */
  laneStart?: boolean;
  /**
   * Whether "Split lanes by provider" is on. In band mode the header is a
   * spanning color band over a provider; off, it's a standard-height header
   * (lane columns tinted, "Other" plain) so lens headers match the provider view.
   */
  bandMode?: boolean;
}

export const isBlockedTimeCalendarEvent = (
  event: CalendarEvent,
): event is CalendarEvent & { eventType: 'blocked_time'; blockedTime: BlockedTimeOccurrence } =>
  event.eventType === 'blocked_time' && Boolean(event.blockedTime);
